import { render, staticRenderFns } from "./deployment_status_badge.vue.js?vue&type=template&id=5f89577b&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deployment_status_badge.vue?vue&type=template&id=5f89577b&vue3"
import script from "./deployment_status_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deployment_status_badge.vue?vue&type=script&lang=js&vue3"
export * from "./deployment_status_badge.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./deployment_status_badge.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports